import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListGroupSettingModel, SettingModel } from '../model/setting.model';
import { SettingServiceRest } from './setting.service-rest';

@Injectable()
export class SettingService {
  constructor(private serviceRest: SettingServiceRest) { }

  getSetting(param: string): Observable<ListGroupSettingModel[]> {
    return this.serviceRest.getSetting(param);
  }

  setSetting(model: SettingModel): Observable<SettingModel> {
    return this.serviceRest.setSetting(model);
  }
}
